import { defineStore } from "pinia";
import { asset_host } from "@/settings/settings";

export const useStateStore = defineStore({
  id: 'state',

  state: () => ({
    bandwidth: 0,
    loading: false,
    tutorialShown: false,
    error: null,
    success: null,
    birdsEyeView: true,
    selectedRoom: null,
    selectedProduct: null,
    roomStack: [],
    sideSheetOpen: false,
    navigationOpen: false,
    flapperHighscore: 0,
    jumperHighscore: 0,
    playerName: ''
  }),

  persist: {
    pick: ['selectedRoom', 'tutorialShown', 'flapperHighscore', 'jumperHighscore', 'playerName'],
  },

  actions: {
    // Retruns the current bandwidth in kbps
    measureBandwidth() {
      const start = new Date().getTime();
      fetch(`${asset_host}500k.dat`, {cache: "no-store"})
        .then((response) => {
          const contentLength = response.headers.get('Content-Length') ?? 0;
          const end = new Date().getTime();

          this.bandwidth = Math.floor((contentLength * 8) / ((end - start) / 1000) / 1024);
          console.log(`Downloaded ${contentLength} bytes in ${end - start} ms => Bandwidth (kbps): ${this.bandwidth}`);
        });

    },

    startLoading() {
      this.setLoading(true);
    },

    setProduct(product) {
      this.selectedProduct = product;
    },

    popProduct() {
      this.selectedProduct = null;
    },

    clearRoomStack() {
      this.roomStack = [];
    },

    pushRoom(room) {
      const newStack = this.roomStack.filter(r => r.handle != room.handle);
      newStack.push(room);
      this.roomStack = newStack;
    },

    stopLoading() {
      this.setLoading(false);
    },

    setLoading(loading) {
      this.loading = loading;
    },

    setTutorial(tutorial) {
      this.tutorial = tutorial;
    },

    setError(error) {
      this.error = error;
    },

    setSuccess(success) {
      this.success = success;
    },

    selectRoom(roomId) {
      this.selectedRoom = roomId;
    }
  }
});